const baseEnviroment = {
  apiRoot: window._env_.REACT_APP_API_URL,
  reCaptcha: window._env_.REACT_APP_RECAPTCHA,
};

const environment = {
  TEST: {
    ...baseEnviroment,
    title: "One Customer Portal Dev",
    name: "test"
  },
  PROD: {
    ...baseEnviroment,
    title: "One Customer Portal",
    name: "production"
  }
};

let envVar = {};
switch (window._env_.REACT_APP_STAGE) {
  case "TEST":
    envVar = environment.TEST;
    break;
  case "PROD":
    envVar = environment.PROD;
    break;
  default:
    envVar = environment.TEST;
}

export const env = envVar;
